import React, { useState, useEffect } from 'react'
import { Container, Row, Card } from 'react-bootstrap'
import { useHistory } from 'react-router'
import { useGoogleLogin } from 'react-google-login'
import axios from 'axios'

import { CourseList } from '../../components'
import TranscriptTypeahead from '../../components/TranscriptTypeahead'
import { Course, Transcript } from '../../models'

import './index.css'

const Courses = () => {
  const sampleCourses = []
  const history = useHistory()
  const [courses, setCourses] = useState(sampleCourses)
  const [placeholder, setPlaceholder] = useState('Loading courses...')
  const [isLoading, setLoading] = useState(false)
  const [recordings, setRecordings] = useState([])
  const [searchKey, setSearchKey] = useState('')

  const [isLoadingGoogleAuth, setLoadingGoogleAuth] = useState(true)

  useGoogleLogin({
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    onSuccess: (data) => {
      const { accessToken } = data

      axios.defaults.headers.common['Authorization'] = accessToken
      window.localStorage.setItem('token', accessToken)
    },
    onAutoLoadFinished: () => setLoadingGoogleAuth(false),
    isSignedIn: true,
  })

  const fetchCourses = async () => {
    const maxRetries = 10
    let retryCount = 0

    const fetchData = async () => {
      let courseData
      try {
        courseData = await Course.get()
      } catch (e) {
        console.log('Unable to load courses', e)

        if (retryCount < maxRetries) {
          retryCount++
          setPlaceholder(`Retrying to load courses ${retryCount} / ${maxRetries}`)
          setTimeout(fetchData, 2000)
        } else {
          setPlaceholder('Looks like our servers are busy. Unable to fetch courses at the moment due to rate limits, please try again in a few minutes.')
        }

        return
      }

      courseData = courseData.courses.map(({ id, name }) => ({ id, name }))

      if (!courseData || courseData.length === 0) {
        setPlaceholder('No courses')
      }

      setCourses(courseData)
    }

    return fetchData()
  }

  useEffect(() => {
    if (isLoadingGoogleAuth) return false

    fetchCourses()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingGoogleAuth])

  const handleRedirect = {
    onClick: (e, row) => {
      history.push(`/recordings/${row.id}`, row)
    },
  }

  const handleSearch = (searchKey) => {
    setRecordings([])
    setLoading(true)

    Transcript.search(searchKey)
      .then((matches) => {
        setRecordings(matches)
        setSearchKey(searchKey)
        setLoading(false)
      })
      .catch((e) => {
        setLoading(false)
        setRecordings([])
      })
  }

  const handleChange = (selected) => {
    const { recordingId } = selected[0]
    history.push(`/recording/${recordingId}`, { searchKey })
  }

  return (
    <Container>
      <Card className="courses-card">
        <Row>
          <p className="courses-header">Courses</p>
        </Row>
        <Row id="transcriptRow">
          <TranscriptTypeahead
            isLoading={isLoading}
            handleSearch={handleSearch}
            handleChange={handleChange}
            recordings={recordings}
          />
        </Row>
        <Row>
          <CourseList
            courses={courses}
            handleRedirect={handleRedirect}
            placeholder={placeholder}
          />
        </Row>
      </Card>
    </Container>
  )
}

export default Courses
